import CreateLabel from '../../pages/labels/CreateLabel.vue';
import Labels from '../../pages/labels/Labels.vue';
import EditLabel from '../../pages/labels/EditLabel.vue';
import Label from '../../pages/labels/Label.vue';

export default [
  {
    path: '/v2/admin/labels',
    name: 'admin.labels.index',
    component: Labels,
    meta: {
      permission: 'can_edit_labels',
    },
  },
  {
    path: '/v2/admin/labels/create',
    name: 'admin.labels.create',
    component: CreateLabel,
    meta: {
      permission: 'can_edit_labels',
    },
  },
  {
    path: '/v2/admin/labels/:labelID(\\d+)',
    component: Label,
    children: [
      {
        path: 'edit',
        name: 'admin.labels.edit',
        component: EditLabel,
        meta: {
          permission: 'can_edit_labels',
        },
      },
    ]
  },

]

